module.exports = __webpack_public_path__ + "img/slider4new.e96525d8.png";